const COMMON_FIELDS = {
  value: { key: "valor", label: "Valor", type: "number", placeholder: "0", required: true },
  valuation: { key: "valuation", label: "Valor", type: "currency", placeholder: "0", required: true },
  currency: { key: "currency_type", label: "Moneda de valuación", type: "select", options: ["USD", "MXN", "COP", "CHF",  "GBP", "EUR", "Otro"], otherEditable: true, otherPlaceholderKey: "other_currency_placeholder", required: true },
  valuationDate: { key: "fecha_valuacion", label: "Fecha de valuación", type: "date" },
  country: { key: "pais", label: "País en donde está la inversión", type: "select", options: ["United States", "Mexico", "Colombia", "Swiss", "UK", "Spain", "Other"], otherEditable: true },
  structure: { key: "estructura_vinculada", label: "Estructura vinculada", type: "text", placeholder: "Ej: Fideicomiso Familiar 2020" },
  linkedStructure: {
    key: "estructura_vinculada",
    label: "Estructuras a las que este activo está vinculado",
    tooltip: "Indica si este activo está a nombre de un fideicomiso, corporación u otra entidad legal. Si lo tienes directamente a tu nombre, deja este campo vacío.",
    manualOptionCopyKey: "link_new_structure",
    type: "linked_select",
    linkedTarget: "structures",
  },
  linkedAssets: { key: "activo_vinculado", label: "Activos vinculados", type: "asset_link_selector", linkedTarget: "assets" },
  linkedLiability: {
    key: "pasivo_vinculado",
    labelCopyKey: "linked_liability_asset",
    label: "Pasivos a los que este activo está vinculado",
    manualOptionCopyKey: "link_new_liability",
    type: "linked_select",
    linkedTarget: "liabilities",
  },
  linkedLiabilities: { key: "pasivo_vinculado", label: "Pasivos vinculados", type: "linked_select", linkedTarget: "liabilities", multiple: true },
  participation: { key: "participacion", label: "Porcentaje de participación", type: "percentage", placeholder: "Ej: 80", maxValue: 100 },
  otherOwners: { key: "otros_duenos", label: "Otros propietarios", type: "text", placeholder: "Indica quien posee el porcentaje restante" },
};

const LIABILITY_FIELDS = [
  COMMON_FIELDS.currency,
  { key: "principal", label: "Cantidad principal", type: "currency", placeholder: "0", required: true },
  { key: "tipo_pasivo", label: "Tipo de pasivo", type: "select", options: ["Accounts payable", "Interest payable", "Income taxes payable", "Bills payable", "Bank account overdrafts", "Accrued expenses", "Mortgage Loan", "Personal Credit Loan", "Other"] },
  COMMON_FIELDS.linkedStructure,
  COMMON_FIELDS.linkedAssets,
  { key: "colateral", label: "Colateral", type: "select", options: ["Yes", "No"] },
];

export const SECTIONS = {
  cuentas_inversion: {
    pillar: "Activos",
    title: "Cuentas de inversión",
    sub: "Cuentas con custodios y casas de bolsa",
    addLabel: "Agregar cuenta de inversión",
    icon: "cash",
    tone: "asset",
    payloadKey: "investment_accounts",
    nameKey: "custodio",
    fields: [
      { key: "numero_cuenta", label: "Nombre o referencia de la cuenta", type: "text", placeholder: "Ej. Cuenta 1, BBVA 1234", tooltip: "Ingresa un nombre, abreviatura o los últimos 4 dígitos que te permitan distinguir esta cuenta de otras. No es necesario proporcionar el número completo.", required: true },
      { key: "custodio", label: "Institución Financiera", type: "text", placeholder: "Ej: Morgan Stanley, GBM", required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      COMMON_FIELDS.country,
      COMMON_FIELDS.linkedStructure,
    ],
  },
  inversiones_alternativas: {
    pillar: "Activos",
    title: "Inversiones alternativas",
    sub: "Private equity, hedge funds, capital de riesgo",
    addLabel: "Agregar inversion alternativa",
    icon: "trend",
    tone: "asset",
    payloadKey: "alternative_investments",
    nameKey: "nombre",
    fields: [
      { key: "nombre", labelCopyKey: "alternative_investment_name", label: "Nombre o referencia de la inversión", type: "text", placeholder: "Ej: Fondo de capital privado XYZ", required: true },
      { key: "tipo_inversion", labelCopyKey: "investment_type", label: "Tipo de inversión", type: "select", options: ["Capital Privado", "Capital de Riesgo", "Bienes Raíces", "Fondos de Cobertura", "Deuda Privada", "Infraestructura", "Coinversiones"], required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      COMMON_FIELDS.country,
      COMMON_FIELDS.linkedStructure,
    ],
  },
  cuentas_bancarias: {
    pillar: "Activos",
    title: "Chequeras",
    sub: "Chequeras y cuentas de deposito",
    addLabel: "Agregar chequera",
    icon: "card",
    tone: "asset",
    payloadKey: "bank_accounts",
    nameKey: "banco",
    fields: [
      { key: "nombre_numero_cuenta", label: "Nombre o referencia de la chequera", type: "text", placeholder: "Ej: Cuenta principal o 0000-0000", required: true },
      { key: "banco", label: "Institución Financiera", type: "text", placeholder: "Ej: BBVA, Santander", required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      { ...COMMON_FIELDS.country, labelCopyKey: "checking_account_country", label: "País de la chequera" },
      COMMON_FIELDS.linkedStructure,
    ],
  },
  cuentas_cobrar: {
    pillar: "Activos",
    title: "Cuentas por cobrar",
    sub: "Prestamos otorgados pendientes de cobro",
    addLabel: "Agregar cuenta por cobrar",
    icon: "message",
    tone: "asset",
    payloadKey: "accounts_receivable",
    nameKey: "nombre",
    fields: [
      { key: "nombre", labelCopyKey: "receivable_name", label: "Nombre o referencia de la cuenta por cobrar", type: "text", placeholder: "Ej: Prestamo empresa familiar", required: true },
      { key: "tipo_prestamo", label: "Tipo de préstamo", type: "select", options: ["Installment Loans", "Pure Interest Loans", "No Interest Loan"], required: true },
      COMMON_FIELDS.currency,
      { key: "principal", label: "Cantidad principal", type: "currency", placeholder: "0", required: true },
      COMMON_FIELDS.linkedStructure,
    ],
  },
  propiedades: {
    pillar: "Activos",
    title: "Propiedades inmobiliarias",
    sub: "Casas, terrenos, departamentos, locales",
    addLabel: "Agregar propiedad",
    icon: "home",
    tone: "asset",
    payloadKey: "real_estates",
    nameKey: "nombre",
    fields: [
      { key: "nombre", labelCopyKey: "property_name", label: "Nombre o referencia de la propiedad", type: "text", placeholder: "Ej: Casa Lomas, Terreno Valle", required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      COMMON_FIELDS.valuationDate,
      { key: "uso", label: "Uso", type: "select", options: ["Residencia principal", "Residencia Vacacional", "Renta", "Comercial", "Otro"], required: true },
      COMMON_FIELDS.country,
      COMMON_FIELDS.participation,
      COMMON_FIELDS.otherOwners,
      COMMON_FIELDS.linkedStructure,
      COMMON_FIELDS.linkedLiability,
    ],
  },
  inversiones_directas: {
    pillar: "Activos",
    title: "Inversiones directas",
    sub: "Participaciones en compañías y proyectos",
    addLabel: "Agregar inversion directa",
    icon: "briefcase",
    tone: "asset",
    payloadKey: "direct_investments",
    nameKey: "nombre",
    fields: [
      { key: "nombre", labelCopyKey: "investment_name", label: "Nombre o referencia de la Inversión", type: "text", placeholder: "Ej: Restaurantes del Norte SA", required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      COMMON_FIELDS.country,
      COMMON_FIELDS.participation,
      COMMON_FIELDS.otherOwners,
      COMMON_FIELDS.linkedStructure,
      COMMON_FIELDS.linkedLiability,
    ],
  },
  vehiculos_colecciones: {
    pillar: "Activos",
    title: "Vehículos y colecciones",
    sub: "Autos, embarcaciones, aeronaves, arte, relojes",
    addLabel: "Agregar bien",
    icon: "clock",
    tone: "asset",
    payloadKey: "vehicles_collections",
    nameKey: "nombre",
    fields: [
      { key: "nombre", label: "Descripcion del bien", type: "text", placeholder: "Ej: Coleccion de relojes, Velero", required: true },
      { key: "tipo", label: "Tipo", type: "select", options: ["Coche/Motocicleta", "Avión/Helicóptero", "Barco", "Relojes", "Arte", "Otro"], required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      COMMON_FIELDS.valuationDate,
      COMMON_FIELDS.otherOwners,
      COMMON_FIELDS.linkedStructure,
      COMMON_FIELDS.linkedLiability,
    ],
  },
  seguros_vida: {
    pillar: "Activos",
    title: "Seguros de vida",
    sub: "Polizas vigentes",
    addLabel: "Agregar poliza",
    icon: "shield",
    tone: "asset",
    payloadKey: "life_insurances",
    nameKey: "numero_poliza",
    fields: [
      { key: "tipo_poliza", label: "Tipo de póliza", type: "select", options: ["Seguro de Vida a Término", "Seguro de Vida Universal Premium Indexado", "Seguro de Vida Universal Premium", "Seguro de Vida Universal Premium Flexible Variable", "Seguro de Vida Toda la Vida", "Seguro de Vida Universal Premium Garantizado"], required: true },
      { key: "numero_poliza", label: "Nombre o abreviación del Seguro", type: "text", placeholder: "POL-000000", required: true },
      COMMON_FIELDS.currency,
      { key: "valor_poliza", label: "Valor de la póliza", type: "currency", placeholder: "0", required: true },
      { key: "indemnizacion", label: "Indemnización por fallecimiento", type: "currency", placeholder: "0", required: true },
      { key: "fecha_valuacion_poliza", label: "Fecha de valuación de la póliza", type: "date" },
      { key: "aseguradora", label: "Aseguradora", type: "text", placeholder: "Ej: John Hancock, GNP" },
      COMMON_FIELDS.linkedStructure,
      COMMON_FIELDS.linkedLiability,
    ],
  },
  otros_activos: {
    pillar: "Activos",
    title: "Otros activos",
    sub: "Criptomonedas, metales preciosos, otros bienes",
    addLabel: "Agregar activo",
    icon: "plus",
    tone: "asset",
    payloadKey: "other_assets",
    nameKey: "nombre",
    fields: [
      { key: "nombre", labelCopyKey: "asset_name", label: "Nombre o referencia del activo", type: "text", placeholder: "Ej: Bitcoin, Oro fisico", required: true },
      { key: "tipo", label: "Tipo", type: "select", options: ["Gold Bullion", "Silver Bullion", "Gold Coins", "Silver Coins", "Other Precious Metals", "Cryptocurrency", "Animals", "Others"], required: true },
      COMMON_FIELDS.currency,
      COMMON_FIELDS.valuation,
      COMMON_FIELDS.valuationDate,
      COMMON_FIELDS.linkedStructure,
      COMMON_FIELDS.linkedLiability,
    ],
  },
  pasivos: {
    pillar: "Pasivos",
    title: "Pasivos",
    sub: "Créditos, hipotecas y otras obligaciones",
    addLabel: "Agregar pasivo",
    icon: "debt",
    tone: "liability",
    payloadKey: "liabilities",
    nameKey: "nombre",
    fields: [{ key: "nombre", label: "Nombre del pasivo", type: "text", placeholder: "Ej: Hipoteca residencia principal", required: true }].concat(LIABILITY_FIELDS),
  },
  estructuras: {
    pillar: "Estructura Patrimonial",
    title: "Fideicomisos y corporaciones",
    sub: "Estructuras legales del patrimonio",
    addLabel: "Agregar estructura",
    icon: "building",
    tone: "structure",
    payloadKey: "structures",
    nameKey: "nombre",
    fields: [
      { key: "nombre", label: "Nombre del fideicomiso o corporacion", type: "text", placeholder: "Ej: Fideicomiso Familiar 2020", required: true },
      { key: "type", label: "Type", type: "select", options: ["Trust", "Corporation"], required: true },
      { ...COMMON_FIELDS.country, labelCopyKey: "structure_country", label: "País en donde está la estructura", required: true },
      COMMON_FIELDS.participation,
      COMMON_FIELDS.otherOwners,
      COMMON_FIELDS.linkedAssets,
      COMMON_FIELDS.linkedLiabilities,
    ],
  },
  arbol_familiar: {
    pillar: "Estructura Patrimonial",
    title: "Relaciones familiares",
    sub: "Miembros de la familia y sus vinculos patrimoniales",
    addLabel: "Agregar miembro",
    icon: "users",
    tone: "structure",
    payloadKey: "family_tree",
    nameKey: "nombre",
    fields: [
      { key: "nombre", label: "Nombre completo", type: "text", placeholder: "Nombre del familiar", required: true },
      { key: "rol", label: "Rol", type: "select", options: ["Conyuge", "Hijo/a", "Padre/Madre", "Hermano/a", "Otro"], otherEditable: true, otherPlaceholderKey: "other_role_placeholder", required: true },
      { key: "nacionalidad", label: "Nacionalidad", type: "select", options: ["Mexicana", "Estadounidense", "Espanola", "Otra"], required: true },
      { ...COMMON_FIELDS.linkedAssets, key: "activo_financiero_vinculado", labelCopyKey: "family_linked_asset", tooltipCopyKey: "family_linked_record", label: "Activo Vinculado" },
      { ...COMMON_FIELDS.linkedLiabilities, labelCopyKey: "family_linked_liability", tooltipCopyKey: "family_linked_record", label: "Pasivo Vinculado" },
      { ...COMMON_FIELDS.linkedStructure, multiple: true },
    ],
  },
};

export const PILLARS = [
  { label: "Activos", ids: ["cuentas_inversion", "inversiones_alternativas", "cuentas_bancarias", "cuentas_cobrar", "propiedades", "inversiones_directas", "vehiculos_colecciones", "seguros_vida", "otros_activos"] },
  { label: "Pasivos", ids: ["pasivos"] },
  { label: "Estructura Patrimonial", ids: ["estructuras", "arbol_familiar"] },
];

export const ASSET_SECTION_IDS = PILLARS[0].ids;
export const LIABILITY_SECTION_IDS = PILLARS[1].ids;
export const STRUCTURE_SECTION_IDS = ["estructuras"];

export const ORDER = PILLARS.reduce((acc, pillar) => acc.concat(pillar.ids), []);

export const FIELD_LABELS = Object.keys(SECTIONS).reduce((labels, sectionId) => {
  SECTIONS[sectionId].fields.forEach((field) => {
    labels[field.key] = field.label;
  });
  return labels;
}, {});

const localizeField = (field, copy) => {
  const fields = copy.fields || {};
  const placeholders = copy.placeholders || {};
  const tooltips = copy.tooltips || {};
  const optionValues = copy.option_values || {};
  const localizeOptions = (options) => options.map((option) => ({ id: option, value: optionValues[option] || option }));
  const localizedOptionsByValue = field.optionsByValue && Object.keys(field.optionsByValue).reduce((groups, key) => {
    const options = localizeOptions(field.optionsByValue[key]);
    groups[key] = options;
    groups[optionValues[key] || key] = options;
    return groups;
  }, {});

  return {
    ...field,
    label: fields[field.labelCopyKey || field.key] || field.label,
    placeholder: placeholders[field.key] || field.placeholder,
    tooltip: tooltips[field.tooltipCopyKey || field.key] || field.tooltip,
    options: field.options ? field.options.map((option) => (
      field.key === "type" ? { id: option, value: optionValues[option] || option } : optionValues[option] || option
    )) : field.options,
    optionsByValue: localizedOptionsByValue || field.optionsByValue,
  };
};

export const getEstateMappingSections = (copy = {}) => {
  const sectionsCopy = copy.sections || {};
  const pillarsCopy = copy.pillars || {};

  return Object.keys(SECTIONS).reduce((sections, sectionId) => {
    const section = SECTIONS[sectionId];
    const sectionCopy = sectionsCopy[sectionId] || {};
    sections[sectionId] = {
      ...section,
      pillar: pillarsCopy[section.pillar] || section.pillar,
      title: sectionCopy.title || section.title,
      sub: sectionCopy.sub || section.sub,
      addLabel: sectionCopy.add_label || section.addLabel,
      fields: section.fields.map((field) => localizeField(field, copy)),
    };
    return sections;
  }, {});
};

export const getEstateMappingPillars = (copy = {}) => {
  const pillarsCopy = copy.pillars || {};

  return PILLARS.map((pillar) => ({
    ...pillar,
    label: pillarsCopy[pillar.label] || pillar.label,
  }));
};

export const getEstateMappingFieldLabels = (sections) => (
  Object.keys(sections).reduce((labels, sectionId) => {
    sections[sectionId].fields.forEach((field) => {
      labels[field.key] = field.label;
    });
    return labels;
  }, {})
);
